<!-- Information Fly -->
<div *ngIf="component !== 'fly'" class="row w-100 m-0" style="background-color: #FFFFFF; min-height: 65px;">
  <!-- First Column -->
  <div
    class="col-4 p-0"
  >
    <div style="border-right: 1px solid #dfdfdf;">
      <div class="px-2 py-3">
        <div class="row">
          <div class="col-4 pr-0">
            <p class="pl-2 mb-0 text-dark" style="font-family: 'Rubik'; font-size: 10.02px">
              Agregar información <br /> de Vuelo
            </p>
          </div>

          <!-- Open Flight Modal Button -->
          <div class="col-1">
            <div class="w-full d-flex align-items-center justify-content-center">
              <button
                type="button"
                class="btn btn-sm text-white"
                style="background-color: black; cursor: pointer"
                data-placement="bottom"
                (click)="openModalWithClass(template, 'new')"
                [disabled]="_actualItinerary === null"
              >
                <img style="filter: invert(1);" width="20px" height="20px" src="../../../assets/icons/itinerary/vuelo_vert.svg" alt="vuelo" />
              </button>
            </div>
          </div>

          <!-- Internal Flight Information -->
          <div
            *ngIf="effectiveFlightsForSummary.length > 0"
            class="col-7 pl-2"
            style="cursor: pointer;"
            [ngStyle]="{ cursor: _actualItinerary?.flights.length > 1 ? 'pointer' : 'default' }"
          >
            <div class="d-flex align-items-end" style="gap: 2px;">
              <!-- FROM -->
              <div
                *ngIf="effectiveFlightsForSummary.length > 0"
                class="d-flex gap-1 align-items-center justify-content-center"
                style="width: 35%; gap: 3px"
              >
                <p class="mb-0" style="font-family: 'Open Sans', serif; font-size: 10.91px; font-weight: bold">
                  {{ getActualFlyInternal(effectiveFlightsForSummary, "airportIataCodeOut") }}
                </p>
                <p class="mb-0" style="font-family: 'Open Sans', serif; font-size: 10.91px">
                  {{ getActualFlyInternal(effectiveFlightsForSummary, "departureOut") | date: "dd MMM yy" }}
                </p>
              </div>

              <!-- LINE -->
              <div class="d-flex flex-column align-items-center justify-content-center" style="width: 25%;">
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 10px; line-height: 1">
                  {{ afterDateFlyOut(getActualFlyInternal(effectiveFlightsForSummary, "departureOut"), getActualFlyInternal(effectiveFlightsForSummary, "arrivalOut")) }}
                </p>

                <div class="d-flex align-items-center w-100 justify-content-center">
                  <div style="height: 1px; border-bottom: 1px dotted #000000; width: 100%"></div>
                  <i class="fa fa-angle-right" style="font-size: 1rem" aria-hidden="true"></i>
                </div>
              </div>

              <!-- TO -->
              <div
                class="d-flex gap-1 align-items-center justify-content-center"
                style="width: 35%; gap: 3px"
                [ngStyle]="{ 'border-right': _actualItinerary?.flights[0]?.arrivalIn ? '1px solid #dfdfdf:' : '' }"
              >
                <p class="mb-0" style="font-family: 'Open Sans', serif; font-size: 10.92px; font-weight: bold">
                  {{ getActualFlyInternal(effectiveFlightsForSummary, "iataCityArrivalOut") }}
                </p>
                <p class="mb-0" style="font-family: 'Open Sans', serif; font-size: 10.92px">
                  {{ getActualFlyInternal(effectiveFlightsForSummary, "arrivalOut") | date: "dd MMM yy" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Second Column -->
  <div
    *ngIf="_actualItinerary?.flights && _actualItinerary?.flights.length > 0 && invoke === 1 && component !== 'fly'"
    class="col-8 p-0"
    (mouseenter)="changeTooltipFlightVisible(true)"
    (mouseleave)="changeTooltipFlightVisible(false)"
  >
    <!-- Flight Information -->
    <div class="d-flex align-items-center h-100 pl-3">
      <div class="d-flex justify-content-between align-items-center" style="cursor: pointer; width: 100%">
        <div *ngIf="_actualItinerary?.flights[0]?.arrivalIn" class="w-100 d-flex gap-1 align-items-center">
          <img class="ml-3 mr-2" width="28px" src="../../../../assets/icons/itinerary/AVIONLINEA.svg" alt="" />

          <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 11px">
            <span style="font-weight: 600; color: #444f5d;">
              {{ _actualItinerary?.flights[0]?.arrivalIn | date: "dd MMM yy" }}
            </span>
            <span class="ml-1">
              {{ _actualItinerary?.flights[0]?.airlineIn }} - {{ _actualItinerary?.flights[0]?.flyNumberIn }} Arr:
              {{ getHourFly(_actualItinerary?.flights[0]?.arrivalIn) }} {{ _actualItinerary?.flights[0]?.airportIataCodeIn }}
            </span>
          </p>
        </div>
        <div
          *ngIf="_actualItinerary?.flights[0]?.departureOut"
          class="w-100 d-flex gap-1 align-items-center"
          [ngStyle]="{ 'border-right': _actualItinerary?.flights[0]?.arrivalIn ? '1px solid #dfdfdf:' : '' }"
        >
          <img class="ml-3 mr-2" width="28px" style="transform: rotate(25deg)" src="../../../../assets/icons/itinerary/AVIONLINEA.svg" alt="" />

          <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 11px">
            <span style="font-weight: 600; color: #444f5d;">
              {{ _actualItinerary?.flights[0]?.departureOut | date: "dd MMM yy" }}
            </span>
            <span class="ml-1">
              {{ _actualItinerary?.flights[0]?.airlineOut }} - {{ _actualItinerary?.flights[0]?.flyNumberOut }} Dep:
              {{ getHourFly(_actualItinerary?.flights[0]?.departureOut) }} {{ _actualItinerary?.flights[0]?.airportIataCodeOut }}
            </span>
          </p>
        </div>
      </div>
    </div>

    <!-- Tooltip Internal Flight Information -->
    <ng-container *ngIf="tooltipFlight && effectiveFlightsForSummary.length > 0">
      <div
        class="d-flex justify-content-between align-items-center w-100 shadow-md"
        style="
          border: 1px solid #dfdfdf;
          border-radius: 6px;
          padding-top: 0.35em;
          padding-bottom: 0.35em;
          background-color: #f3fef9;
          position: absolute;
          bottom: -103px;
          z-index: 99999;
        "
      >
        <div class="d-flex justify-content-between align-items-start px-4" style="width: 100%">
          <ng-container *ngFor="let fly of getFlyArr(_actualItinerary?.flights); let i = index">
            <div class="d-flex flex-column align-items-center" style="min-width: 110px;">
              <img src="../../../assets/icons/itinerary/lugar.svg" style="width: 40px;" alt="" />
              <p
                class="mb-0"
                style="font-family: &quot;Rubik&quot;, serif; font-weight: 600; color: #000000;"
              >
                {{ getDataTooltip(fly, i, "iata") }}
              </p>
              <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-weight: 500; text-transform: capitalize">
                {{ getDataTooltip(fly, i, "date") | date: "dd MMM" }}
              </p>
              <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-weight: 400">
                {{ getHourFly(getDataTooltip(fly, i, "date")) }}
              </p>
              <!-- (i !== _actualItinerary?.flights.length - 1)  ? (getHourFly(fly?.arrivalIn)+' / '+getHourFly(fly?.departureIn)) : (getHourFly(fly?.departureOut)+' / '+getHourFly(fly?.arrivalOut)) -->
            </div>
            <div class="d-flex align-items-center" style="width: 80%" *ngIf="i !== getFlyArr(_actualItinerary?.flights).length - 1">
              <div class="mt-2" style="height: 2px; border-bottom: 2px dashed #000000; width: 75%"></div>
              <img class="mt-2 mx-2" src="../../../assets/icons/itinerary/airplane-plane-svgrepo-com.svg" style="width: 30px" alt="" />
              <div class="mt-2" style="height: 2px; border-bottom: 2px dashed #000000; width: 75%"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Flight Form -->
<ng-template #template style="background: transparent">
  <form
    [formGroup]="_formFlights"
    [class.flight-form-readonly]="hasReservedItem"
    class="flight-modal"
    (ngSubmit)="_flightsApply()"
  >
    <!-- ============================== HEADER ============================== -->
    <header class="flight-modal__header">
      <div class="flight-modal__heading">
        <span class="flight-modal__heading-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.4c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.8 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
          </svg>
        </span>
        <div class="flight-modal__heading-text">
          <h3 *ngIf="component !== 'fly'" class="flight-modal__title">
            {{ _actualItinerary?.flights.length === 0 ? "Nuevo vuelo" : "Vuelo general" }}
          </h3>
          <h3 *ngIf="component === 'fly'" class="flight-modal__title">
            Vuelo de file {{ flyShowComponent?.itineraries?.id }}
          </h3>
          <p class="flight-modal__subtitle">Datos del vuelo principal del file</p>
        </div>
      </div>

      <div class="flight-modal__actions">
        <button
          *ngIf="((flightsInternal && flightsInternal.length === 0) || flightsInternalIds())"
          type="button"
          class="btn-flight-secondary"
          tooltip="Crear vuelo interno"
          (click)="createFlyInternal()"
          placement="bottom"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M5 12h14" /><path d="M12 5v14" />
          </svg>
          <span>Crear vuelo interno</span>
        </button>

        <button
          *ngIf="isTransfersContext && onlyIn && !onlyOut && !legUnlocked && !hasReservedItem"
          type="button"
          class="btn-flight-secondary"
          tooltip="Agregar vuelo de salida"
          (click)="addMissingLeg()"
          placement="bottom"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M5 12h14" /><path d="M12 5v14" />
          </svg>
          <span>Agregar vuelo de salida</span>
        </button>

        <!--
          Mirror button for the arrival leg: shows when only the departure is
          currently visible. Uses addMissingArrivalLeg() for symmetry with
          addMissingLeg() — both are one-line wrappers over setLegVisible().
        -->
        <button
          *ngIf="isTransfersContext && !onlyIn && onlyOut && !hasReservedItem"
          type="button"
          class="btn-flight-secondary"
          tooltip="Agregar vuelo de llegada"
          (click)="addMissingArrivalLeg()"
          placement="bottom"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M5 12h14" /><path d="M12 5v14" />
          </svg>
          <span>Agregar vuelo de llegada</span>
        </button>

        <button
          *ngIf="_actualItinerary?.flights && _actualItinerary?.flights.length > 0 && _actualItinerary?.flights[0]?.id && !hasReservedItem"
          type="button"
          class="btn-flight-danger"
          tooltip="Eliminar vuelo"
          (click)="_removeFlight(_actualItinerary.flights[0].id, true)"
          placement="bottom"
          aria-label="Eliminar vuelo"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M18 6 6 18" /><path d="m6 6 12 12" />
          </svg>
        </button>
      </div>
    </header>

    <!-- ============================== BODY ============================== -->
    <div role="document" class="flight-modal__body" id="modal-edit-flight">

      <!-- ============================== LLEGADA ============================== -->
      <section *ngIf="onlyIn" class="flight-leg">
        <header class="flight-leg__header">
          <span class="flight-leg__icon" aria-hidden="true">
            <svg class="flight-leg__plane flight-leg__plane--in" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.4c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.8 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
            </svg>
          </span>
          <div class="flight-leg__heading">
            <h4 class="flight-leg__title">Llegada</h4>
            <p class="flight-leg__hint">Vuelo de ingreso al destino</p>
          </div>
          <button
            *ngIf="onlyIn && onlyOut && !_isRoundTripAirportBothEnds() && !hasReservedArrivalLeg"
            type="button"
            class="flight-leg__remove"
            tooltip="Quitar vuelo de llegada"
            (click)="removeMissingArrivalLeg()"
            placement="bottom"
            aria-label="Quitar vuelo de llegada"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M18 6 6 18" /><path d="m6 6 12 12" />
            </svg>
          </button>
        </header>

        <div class="flight-leg__body">
          <div class="flight-grid">
            <!-- Aerolínea -->
            <div class="flight-field">
              <label class="flight-field__label" for="airlineIn">Aerolínea</label>
              <div class="flight-field__control" [class.flight-field__control--locked]="selectedAirlineInName !== ''">
                <span class="flight-field__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.4c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.8 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                  </svg>
                </span>

                <!-- Autocomplete -->
                <input
                  *ngIf="selectedAirlineInName === ''"
                  (valueChanged)="_myCallbackAirlineIn($event)"
                  ngui-auto-complete
                  formControlName="airlineIn"
                  type="text"
                  id="airlineIn"
                  name="Airline"
                  class="flight-field__input"
                  value-formatter="name"
                  placeholder="Ej. Aerolíneas Argentinas"
                  [source]="getAutoCompleteSource('airline')"
                  display-property-name="name"
                  [list-formatter]="_myListFormatterAirline"
                  accept-user-input="false"
                  autocomplete="off"
                  [attr.readonly]="hasReservedArrivalLeg ? '' : null"
                />

                <!-- Selected airline (readonly surface) -->
                <input
                  *ngIf="selectedAirlineInName !== ''"
                  [value]="selectedAirlineInName"
                  type="text"
                  id="airlineIn-display"
                  name="Airline"
                  class="flight-field__input flight-field__input--locked"
                  [ngStyle]="{ 'pointer-events': (component === 'fly' || hasReservedArrivalLeg) ? 'none' : 'auto' }"
                  [attr.readonly]="hasReservedArrivalLeg || component === 'fly' ? '' : null"
                />

                <!-- Airline IATA code chip -->
                <input
                  *ngIf="_formFlights.get('_flightNumberIn')?.value"
                  formControlName="_flightNumberIn"
                  type="text"
                  class="flight-chip"
                  id="_flight-numberIn"
                  autocomplete="off"
                  [attr.readonly]="hasReservedArrivalLeg || component === 'fly' ? '' : null"
                />

                <button
                  *ngIf="selectedAirlineInName !== '' && component !== 'fly' && !hasReservedArrivalLeg"
                  type="button"
                  class="flight-field__clear"
                  tooltip="Eliminar Aerolínea de llegada"
                  placement="bottom"
                  (click)="deleteSelectedOption('airlineIn')"
                  aria-label="Eliminar Aerolínea de llegada"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                  </svg>
                </button>
              </div>
              <p class="flight-field__error" *ngIf="selectedAirlineInName === '' && _formFlights.get('airlineIn').touched">
                Ingrese una aerolínea y seleccione una opción
              </p>
            </div>

            <!-- Número de vuelo -->
            <div class="flight-field">
              <label class="flight-field__label" for="flight-numberIn">Número de vuelo</label>
              <div class="flight-field__control">
                <input
                  *ngIf="component !== 'fly'"
                  formControlName="flightNumberIn"
                  type="text"
                  class="flight-field__input"
                  id="flight-numberIn"
                  placeholder="Ej. AR 1234"
                  maxlength="4"
                  [attr.readonly]="hasReservedArrivalLeg ? '' : null"
                />
                <input
                  *ngIf="component === 'fly'"
                  formControlName="flightNumberIn"
                  type="text"
                  class="flight-field__input"
                  id="flight-numberIn"
                  placeholder="Ej. AR 1234"
                  maxlength="4"
                  [ngStyle]="{ 'pointer-events': (component === 'fly' || hasReservedArrivalLeg) ? 'none' : 'auto' }"
                  [attr.readonly]="hasReservedArrivalLeg ? '' : null"
                />
              </div>
              <p class="flight-field__error" *ngIf="_formFlights.get('flightNumberIn').touched && _formFlights.get('flightNumberIn').invalid">
                Ingrese número de vuelo
              </p>
            </div>

            <!-- Aeropuerto -->
            <div class="flight-field">
              <label class="flight-field__label" for="airportIn">Aeropuerto</label>
              <div class="flight-field__control" [class.flight-field__control--locked]="_formFlights.get('airportIn')?.value?.name">
                <span class="flight-field__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
                  </svg>
                </span>

                <!-- Autocomplete -->
                <input
                  *ngIf="!_formFlights.get('airportIn')?.value?.name"
                  (valueChanged)="_myCallbackAirportIn($event)"
                  ngui-auto-complete
                  formControlName="airportIn"
                  type="text"
                  name="airportIn"
                  class="flight-field__input"
                  value-formatter="name"
                  placeholder="Ej. Ezeiza (EZE)"
                  [source]="getAutoCompleteSource('airport')"
                  display-property-name="name"
                  [list-formatter]="_myListFormatterAirport"
                  accept-user-input="false"
                  autocomplete="off"
                  loading-template="Cargando aeropuertos..."
                  [attr.readonly]="hasReservedArrivalLeg ? '' : null"
                />

                <!-- Selected airport (readonly surface) -->
                <input
                  *ngIf="_formFlights.get('airportIn')?.value?.name"
                  [value]="_formFlights.get('airportIn').value?.name || _formFlights.get('airportIn').value"
                  type="text"
                  name="airportIn"
                  class="flight-field__input flight-field__input--locked"
                  [attr.tabindex]="-1"
                  [ngStyle]="{ 'pointer-events': 'none', 'background-color': 'transparent', 'cursor': 'not-allowed' }"
                  [attr.readonly]="true"
                  [disabled]="true"
                  (keydown)="$event.preventDefault()"
                  (keypress)="$event.preventDefault()"
                  (beforeinput)="$event.preventDefault()"
                  (input)="$event.preventDefault()"
                  (mousedown)="$event.preventDefault()"
                  (click)="$event.preventDefault()"
                />

                <button
                  *ngIf="!isAirportLocked('airportIn') && component !== 'fly' && !hasReservedArrivalLeg"
                  type="button"
                  class="flight-field__clear"
                  tooltip="Eliminar Aeropuerto de llegada"
                  placement="bottom"
                  (click)="deleteSelectedOption('airportIn')"
                  aria-label="Eliminar Aeropuerto de llegada"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                  </svg>
                </button>
              </div>
              <p class="flight-field__error" *ngIf="!_formFlights.get('airportIn')?.value?.name && _formFlights.get('airportIn').touched">
                Ingrese un aeropuerto y seleccione una opción
              </p>
            </div>

            <!-- Terminal -->
            <div class="flight-field">
              <label class="flight-field__label" for="terminalIn">
                Terminal <span class="flight-field__optional">(opcional)</span>
              </label>
              <div class="flight-field__control">
                <input
                  formControlName="terminalIn"
                  type="text"
                  class="flight-field__input"
                  id="terminalIn"
                  placeholder="Ej. Terminal A"
                  maxlength="20"
                  autocomplete="off"
                  [attr.readonly]="hasReservedArrivalLeg || component === 'fly' ? '' : null"
                />
              </div>
            </div>

            <!-- Fecha de llegada -->
            <div class="flight-field">
              <label class="flight-field__label" for="arrivalDateIn">Fecha de llegada</label>
              <div class="flight-field__control" [class.flight-field__control--locked]="isDateLocked('arrivalDateIn')">
                <span class="flight-field__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h18" />
                  </svg>
                </span>

                <!-- Editable date (opens the datepicker on click) -->
                <input
                  *ngIf="!isDateLocked('arrivalDateIn')"
                  formControlName="arrivalDateIn"
                  type="text"
                  class="flight-field__input"
                  id="arrivalDateIn"
                  placeholder="Seleccioná la fecha"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="minDate"
                  [bsConfig]="arrivalDateInConfig"
                  [attr.readonly]="hasReservedArrivalLeg || component === 'fly' ? '' : null"
                />

                <!-- Locked date -->
                <input
                  *ngIf="isDateLocked('arrivalDateIn')"
                  formControlName="arrivalDateIn"
                  type="text"
                  class="flight-field__input flight-field__input--locked"
                  id="arrivalDateIn-display"
                  placeholder="Fecha de llegada"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="minDate"
                  [bsConfig]="arrivalDateInConfig"
                  [ngStyle]="{ 'pointer-events': 'none', 'background-color': 'transparent', 'cursor': 'not-allowed' }"
                  [attr.readonly]="true"
                />

                <button
                  *ngIf="_formFlights.get('arrivalDateIn').value && component !== 'fly' && !hasReservedArrivalLeg"
                  type="button"
                  class="flight-field__clear flight-field__clear--visible"
                  tooltip="Eliminar fecha de llegada"
                  placement="bottom"
                  (click)="_clearDate('arrivalDateIn')"
                  aria-label="Eliminar fecha de llegada"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                  </svg>
                </button>
              </div>
              <p class="flight-field__error" *ngIf="_formFlights.get('arrivalDateIn').touched && _formFlights.get('arrivalDateIn').invalid">
                Ingrese una fecha de llegada
              </p>
            </div>

            <!-- Hora de llegada -->
            <div class="flight-field">
              <label class="flight-field__label" for="arrivalHourIn">Hora de llegada</label>
              <div class="wheel-picker-wrapper" [class.disabled-wrapper]="!_formFlights.get('arrivalDateIn').value">
                <div class="flight-field__control" [class.flight-field__control--locked]="!_formFlights.get('arrivalDateIn').value">
                  <input
                    type="text"
                    class="flight-field__input"
                    id="arrivalHourIn"
                    [value]="_formFlights.get('arrivalHourIn').value"
                    [ngStyle]="{ 'pointer-events': (component === 'fly' || hasReservedArrivalLeg || !_formFlights.get('arrivalDateIn').value) ? 'none' : 'auto' }"
                    (input)="_onManualTimeInput($event, 'arrivalHourIn')"
                    (blur)="_onTimeInputBlur('arrivalHourIn', $event)"
                    placeholder="HH:MM"
                    inputmode="numeric"
                    maxlength="5"
                    pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
                  />
                  <span
                    class="flight-field__action"
                    [ngStyle]="{ 'cursor': (hasReservedArrivalLeg || component === 'fly' || !_formFlights.get('arrivalDateIn').value) ? 'not-allowed' : 'pointer', 'opacity': (hasReservedArrivalLeg || component === 'fly' || !_formFlights.get('arrivalDateIn').value) ? '0.5' : '1' }"
                    (click)="(!hasReservedArrivalLeg && component !== 'fly' && _formFlights.get('arrivalDateIn').value) ? toggleTimePicker('arrivalHourIn', $event) : null; $event.stopPropagation()"
                    aria-hidden="true"
                  >
                    <img src="../../../../../assets/icons/search-box/reloj-traslado.svg" width="18px" alt="" />
                  </span>
                </div>

                <!-- Dropdown with wheel picker -->
                <div class="wheel-picker-dropdown" *ngIf="activeTimePicker === 'arrivalHourIn' && _formFlights.get('arrivalDateIn').value">
                  <usb-wheel-time-picker
                    formControlName="arrivalHourIn"
                    [initialValue]="_formFlights.get('arrivalHourIn').value"
                    [minuteStep]="1"
                    [disabled]="!_formFlights.get('arrivalDateIn').value">
                  </usb-wheel-time-picker>
                </div>
              </div>
              <p class="flight-field__error" *ngIf="_formFlights.get('arrivalHourIn').touched && _formFlights.get('arrivalHourIn').invalid">
                Ingrese una hora de llegada
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- ============================== VUELOS INTERNOS ============================== -->
      <ng-container *ngIf="flightsInternal && flightsInternal.length > 0">
        <section class="flight-leg flight-leg--internal">
          <header class="flight-leg__header">
            <span class="flight-leg__icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.4c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.8 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
              </svg>
            </span>
            <div class="flight-leg__heading">
              <h4 class="flight-leg__title">Vuelos internos</h4>
              <p class="flight-leg__hint">Agregá los vuelos internos del file</p>
            </div>
          </header>
          <div class="flight-leg__body flight-leg__body--internal">
            <usb-form-flight-internal
              [flightsInternal]="flightsInternal"
              [getClientsSettingAppBooking]="getClientsSettingAppBooking"
              [firstFly]="_actualItinerary?.flights && _actualItinerary?.flights.length > 0 && _actualItinerary?.flights[0]"
              [formTransports]="formTransports"
              [component]="component"
              [itineraryId]="_actualItinerary?.id"
              (formValidityChange)="onFormValidityChange($event)"
              (deleteFly)="deleteFlyInternal($event)"
              (submitFly)="submitFlyInternals()"
              (accordionStateChange)="onChildAccordionStateChange($event)"
            ></usb-form-flight-internal>
          </div>
        </section>
      </ng-container>

      <!--
        Swap button between arrival and departure legs. Clicking inverts every
        field of the general flight so the arrival becomes the departure and
        vice versa.
      -->
      <div *ngIf="isTransfersContext && onlyIn && onlyOut && !hasReservedItem" class="flight-swap">
        <button
          type="button"
          class="flight-swap__button"
          [class.is-rotated]="isRotatedSwap"
          tooltip="Invertir llegada y salida"
          placement="bottom"
          (mouseenter)="isHoveredSwapBtn = true"
          (mouseleave)="isHoveredSwapBtn = false"
          (click)="swapFlightLegs()"
          aria-label="Invertir llegada y salida"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="m21 16-4 4-4-4" /><path d="M17 20V4" /><path d="m3 8 4-4 4 4" /><path d="M7 4v16" />
          </svg>
        </button>
      </div>

      <!-- ============================== SALIDA ============================== -->
      <section *ngIf="onlyOut" class="flight-leg">
        <header class="flight-leg__header">
          <span class="flight-leg__icon" aria-hidden="true">
            <svg class="flight-leg__plane flight-leg__plane--out" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.4c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.8 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
            </svg>
          </span>
          <div class="flight-leg__heading">
            <h4 class="flight-leg__title">Salida</h4>
            <p class="flight-leg__hint">Vuelo de egreso del destino</p>
          </div>
          <button
            *ngIf="onlyIn && onlyOut && !_isRoundTripAirportBothEnds() && !hasReservedDepartureLeg"
            type="button"
            class="flight-leg__remove"
            tooltip="Quitar vuelo de salida"
            (click)="removeMissingLeg()"
            placement="bottom"
            aria-label="Quitar vuelo de salida"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M18 6 6 18" /><path d="m6 6 12 12" />
            </svg>
          </button>
        </header>

        <div class="flight-leg__body">
          <div class="flight-grid">
            <!-- Aerolínea -->
            <div class="flight-field">
              <label class="flight-field__label" for="airlineOut">Aerolínea</label>
              <div class="flight-field__control" [class.flight-field__control--locked]="selectedAirlineOutName !== ''">
                <span class="flight-field__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.4c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.8 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                  </svg>
                </span>

                <!-- Autocomplete -->
                <input
                  *ngIf="selectedAirlineOutName === ''"
                  (valueChanged)="_myCallbackAirlineOut($event)"
                  ngui-auto-complete
                  formControlName="airlineOut"
                  type="text"
                  id="airlineOut"
                  name="Airline"
                  class="flight-field__input"
                  value-formatter="name"
                  placeholder="Ej. Aerolíneas Argentinas"
                  [source]="getAutoCompleteSource('airline')"
                  display-property-name="name"
                  [list-formatter]="_myListFormatterAirline"
                  accept-user-input="false"
                  autocomplete="off"
                  [attr.readonly]="hasReservedDepartureLeg ? '' : null"
                />

                <!-- Selected airline (readonly surface) -->
                <input
                  *ngIf="selectedAirlineOutName !== ''"
                  [value]="selectedAirlineOutName"
                  type="text"
                  id="airlineOut-display"
                  name="Airline"
                  class="flight-field__input flight-field__input--locked"
                  [ngStyle]="{ 'pointer-events': (component === 'fly' || hasReservedDepartureLeg) ? 'none' : 'auto' }"
                  [attr.readonly]="hasReservedDepartureLeg || component === 'fly' ? '' : null"
                />

                <!-- Airline IATA code chip -->
                <input
                  *ngIf="_formFlights.get('_flightNumberOut')?.value"
                  formControlName="_flightNumberOut"
                  type="text"
                  class="flight-chip"
                  id="_flight-numberOut"
                  autocomplete="off"
                  [attr.readonly]="hasReservedDepartureLeg || component === 'fly' ? '' : null"
                />

                <button
                  *ngIf="selectedAirlineOutName !== '' && component !== 'fly' && !hasReservedDepartureLeg"
                  type="button"
                  class="flight-field__clear"
                  tooltip="Eliminar Aerolínea de salida"
                  placement="bottom"
                  (click)="deleteSelectedOption('airlineOut')"
                  aria-label="Eliminar Aerolínea de salida"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                  </svg>
                </button>
              </div>
              <p class="flight-field__error" *ngIf="selectedAirlineOutName === '' && _formFlights.get('airlineOut').touched">
                Ingrese una aerolínea y seleccione una opción
              </p>
            </div>

            <!-- Número de vuelo -->
            <div class="flight-field">
              <label class="flight-field__label" for="flight-numberOut">Número de vuelo</label>
              <div class="flight-field__control">
                <input
                  *ngIf="component !== 'fly'"
                  formControlName="flightNumberOut"
                  type="text"
                  class="flight-field__input"
                  id="flight-numberOut"
                  placeholder="Ej. AR 1234"
                  maxlength="4"
                  [ngStyle]="{ 'pointer-events': (component === 'fly' || hasReservedDepartureLeg) ? 'none' : 'auto' }"
                  [attr.readonly]="hasReservedDepartureLeg ? '' : null"
                />
                <input
                  *ngIf="component === 'fly'"
                  formControlName="flightNumberOut"
                  type="text"
                  class="flight-field__input"
                  id="flight-numberOut"
                  placeholder="Ej. AR 1234"
                  maxlength="4"
                  [ngStyle]="{ 'pointer-events': (component === 'fly' || hasReservedDepartureLeg) ? 'none' : 'auto' }"
                  [attr.readonly]="hasReservedDepartureLeg ? '' : null"
                />
              </div>
              <p class="flight-field__error" *ngIf="_formFlights.get('flightNumberOut')?.touched && _formFlights.get('flightNumberOut')?.invalid">
                Ingrese número de vuelo
              </p>
            </div>

            <!-- Aeropuerto -->
            <div class="flight-field">
              <label class="flight-field__label" for="airportOut">Aeropuerto</label>
              <div class="flight-field__control" [class.flight-field__control--locked]="isAirportLocked('airportOut') || _formFlights.get('airportOut')?.value?.name">
                <span class="flight-field__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
                  </svg>
                </span>

                <!-- Autocomplete -->
                <input
                  *ngIf="!_formFlights.get('airportOut')?.value?.name"
                  (valueChanged)="_myCallbackAirportOut($event)"
                  ngui-auto-complete
                  formControlName="airportOut"
                  type="text"
                  name="airportOut"
                  class="flight-field__input"
                  value-formatter="name"
                  placeholder="Ej. Ezeiza (EZE)"
                  [source]="getAutoCompleteSource('airport')"
                  display-property-name="name"
                  [list-formatter]="_myListFormatterAirport"
                  accept-user-input="false"
                  autocomplete="off"
                  [attr.readonly]="hasReservedDepartureLeg ? '' : null"
                  [disabled]="isAirportLocked('airportOut')"
                  [tabindex]="isAirportLocked('airportOut') ? -1 : 0"
                  [ngStyle]="{ 'pointer-events': isAirportLocked('airportOut') ? 'none' : 'auto' }"
                />

                <!-- Selected airport (readonly surface) -->
                <input
                  *ngIf="_formFlights.get('airportOut')?.value?.name"
                  [value]="_formFlights.get('airportOut').value?.name || _formFlights.get('airportOut').value"
                  type="text"
                  name="airportOut"
                  class="flight-field__input flight-field__input--locked"
                  [attr.tabindex]="-1"
                  [ngStyle]="{ 'pointer-events': 'none', 'background-color': 'transparent', 'cursor': 'not-allowed' }"
                  [attr.readonly]="true"
                  [disabled]="true"
                  (keydown)="$event.preventDefault()"
                  (keypress)="$event.preventDefault()"
                  (beforeinput)="$event.preventDefault()"
                  (input)="$event.preventDefault()"
                  (mousedown)="$event.preventDefault()"
                  (click)="$event.preventDefault()"
                />

                <button
                  *ngIf="!isAirportLocked('airportOut') && component !== 'fly' && !hasReservedDepartureLeg"
                  type="button"
                  class="flight-field__clear"
                  tooltip="Eliminar Aeropuerto de salida"
                  placement="bottom"
                  (click)="deleteSelectedOption('airportOut')"
                  aria-label="Eliminar Aeropuerto de salida"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                  </svg>
                </button>
              </div>
              <p class="flight-field__error" *ngIf="!_formFlights.get('airportOut')?.value?.name && _formFlights.get('airportOut').touched">
                Ingrese un aeropuerto y seleccione una opción
              </p>
            </div>

            <!-- Terminal -->
            <div class="flight-field">
              <label class="flight-field__label" for="terminalOut">
                Terminal <span class="flight-field__optional">(opcional)</span>
              </label>
              <div class="flight-field__control">
                <input
                  formControlName="terminalOut"
                  type="text"
                  class="flight-field__input"
                  id="terminalOut"
                  placeholder="Ej. Terminal A"
                  maxlength="20"
                  autocomplete="off"
                  [attr.readonly]="hasReservedDepartureLeg || component === 'fly' ? '' : null"
                />
              </div>
            </div>

            <!-- Fecha de salida -->
            <div class="flight-field">
              <label class="flight-field__label" for="departureDateOut">Fecha de salida</label>
              <div class="flight-field__control" [class.flight-field__control--locked]="isDateLocked('departureDateOut')">
                <span class="flight-field__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h18" />
                  </svg>
                </span>

                <!-- Editable date (opens the datepicker on click) -->
                <input
                  *ngIf="!isDateLocked('departureDateOut')"
                  formControlName="departureDateOut"
                  type="text"
                  class="flight-field__input"
                  id="departureDateOut"
                  placeholder="Seleccioná la fecha"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="_formFlights.get('arrivalDateIn').value"
                  [placement]="'top'"
                  [bsConfig]="departureDateOutConfig"
                  [attr.readonly]="hasReservedDepartureLeg || component === 'fly' ? '' : null"
                />

                <!-- Locked date -->
                <input
                  *ngIf="isDateLocked('departureDateOut')"
                  formControlName="departureDateOut"
                  type="text"
                  class="flight-field__input flight-field__input--locked"
                  id="departureDateOut-display"
                  placeholder="Fecha de salida"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="_formFlights.get('arrivalDateIn').value"
                  [placement]="'top'"
                  [bsConfig]="departureDateOutConfig"
                  [ngStyle]="{ 'pointer-events': 'none', 'background-color': 'transparent', 'cursor': 'not-allowed' }"
                  [attr.readonly]="true"
                />

                <button
                  *ngIf="_formFlights.get('departureDateOut').value && component !== 'fly' && !hasReservedDepartureLeg"
                  type="button"
                  class="flight-field__clear flight-field__clear--visible"
                  tooltip="Eliminar fecha de salida"
                  placement="bottom"
                  (click)="_clearDate('departureDateOut')"
                  aria-label="Eliminar fecha de salida"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                  </svg>
                </button>
              </div>
              <p class="flight-field__error" *ngIf="_formFlights.get('departureDateOut').touched && _formFlights.get('departureDateOut').hasError('required')">
                Ingrese una fecha de salida
              </p>
            </div>

            <!-- Hora de salida -->
            <div class="flight-field">
              <label class="flight-field__label" for="departureHourOut">Hora de salida</label>
              <div class="wheel-picker-wrapper" [class.disabled-wrapper]="!_formFlights.get('departureDateOut').value">
                <div class="flight-field__control" [class.flight-field__control--locked]="!_formFlights.get('departureDateOut').value">
                  <input
                    type="text"
                    class="flight-field__input"
                    id="departureHourOut"
                    [value]="_formFlights.get('departureHourOut').value"
                    [ngStyle]="{ 'pointer-events': (component === 'fly' || hasReservedDepartureLeg || !_formFlights.get('departureDateOut').value) ? 'none' : 'auto' }"
                    (input)="_onManualTimeInput($event, 'departureHourOut')"
                    (blur)="_onTimeInputBlur('departureHourOut', $event)"
                    placeholder="HH:MM"
                    inputmode="numeric"
                    maxlength="5"
                    pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
                  />
                  <span
                    class="flight-field__action"
                    [ngStyle]="{ 'cursor': (hasReservedDepartureLeg || component === 'fly' || !_formFlights.get('departureDateOut').value) ? 'not-allowed' : 'pointer', 'opacity': (hasReservedDepartureLeg || component === 'fly' || !_formFlights.get('departureDateOut').value) ? '0.5' : '1' }"
                    (click)="(!hasReservedDepartureLeg && component !== 'fly' && _formFlights.get('departureDateOut').value) ? toggleTimePicker('departureHourOut', $event) : null; $event.stopPropagation()"
                    aria-hidden="true"
                  >
                    <img src="../../../../../assets/icons/search-box/reloj-traslado.svg" width="18px" alt="" />
                  </span>
                </div>

                <!-- Dropdown with wheel picker -->
                <div class="wheel-picker-dropdown" *ngIf="activeTimePicker === 'departureHourOut' && _formFlights.get('departureDateOut').value">
                  <usb-wheel-time-picker
                    formControlName="departureHourOut"
                    [initialValue]="_formFlights.get('departureHourOut').value"
                    [minuteStep]="1"
                    [disabled]="!_formFlights.get('departureDateOut').value">
                  </usb-wheel-time-picker>
                </div>
              </div>
              <p class="flight-field__error" *ngIf="_formFlights.get('departureHourOut').touched && _formFlights.get('departureHourOut').hasError('required')">
                Ingrese una hora de salida
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- ============================== NOTA ============================== -->
      <p
        class="flight-modal__note"
        *ngIf="_actualItinerary?.flights && _actualItinerary?.flights.length === 0 && !onlyIn && !onlyOut"
      >
        Una vez creado el vuelo general podrá incorporar los vuelos internos en su file.
      </p>

      <!-- ============================== FOOTER ============================== -->
      <div class="flight-modal__footer" id="apply-btn-r">
        <div class="flight-modal__messages" *ngIf="message && message.length > 0">
          <p *ngFor="let info of message" class="flight-field__error">* {{ info }}</p>
        </div>

        <div class="flight-modal__footer-actions">
          <button (click)="closeModal()" type="button" class="btn-flight-secondary btn-flight-secondary--footer">Cerrar</button>
          <button
            *ngIf="component !== 'fly' && (flightsInternalIds() || isPartialLegValid() || (flightsInternal && flightsInternal.length > 0)) && hasAnyEditableLeg"
            type="submit"
            class="btn-flight-primary"
            [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
